import { createSlice } from "@reduxjs/toolkit";
import {
  getFooterPwaRepo,
  getHeaderDataRepo,
  getTrendingSearchRepo,
  getHeaderSearchDataRepo,
  get404UrlCheckRepo
} from "../../repositories/common";
const commonSlice = createSlice({
  name: "commonReducer",
  initialState: {
    footerPwaLoading: null,
    footerPwa: null,
    footerPwaError: null,
    headerDataLoading: null,
    headerData: null,
    headerDataError: null,
    headerSearchData: null,
    headerSearchDataLoading: null,
    headerSearchDataError: null,
    trendingSearch: null,
    trendingSearchLoading: null,
    trendingSearchError: null,
    url404Data: null,
    url404DataError: null,
  },
  reducers: {
    getFooterPwaLoading(state, action) {
      return {
        ...state,
        footerPwaLoading: true,
      };
    },
    getFooterPwaSuccess(state, action) {
      return {
        ...state,
        footerPwaLoading: false,
        footerPwa: action.payload,
      };
    },
    getFooterPwaFailure(state, action) {
      return {
        ...state,
        footerPwaLoading: false,
        footerPwaError: action.payload,
      };
    },
    getHeaderLoading(state, action) {
      return {
        ...state,
        headerDataLoading: true,
      };
    },
    getHeaderSuccess(state, action) {
      return {
        ...state,
        headerDataLoading: false,
        headerData: action.payload,
      };
    },
    getHeaderFailure(state, action) {
      return {
        ...state,
        headerDataLoading: false,
        headerDataError: action.payload,
      };
    },
    getHeaderSearchDataLoading(state, action) {
      return {
        ...state,
        headerSearchDataLoading: true,
      };
    },
    getHeaderSearchDataSuccess(state, action) {
      return {
        ...state,
        headerSearchDataLoading: false,
        headerSearchData: action.payload,
      };
    },
    getHeaderSearchDataFailure(state, action) {
      return {
        ...state,
        headerSearchDataLoading: false,
        headerSearchDataError: action.payload,
      };
    },
    getTrendingSearchLoading(state, action) {
      return {
        ...state,
        trendingSearchLoading: true,
      };
    },
    getTrendingSearchSuccess(state, action) {
      return {
        ...state,
        trendingSearchLoading: false,
        trendingSearch: action.payload,
      };
    },
    getTrendingSearchFailure(state, action) {
      return {
        ...state,
        trendingSearchLoading: false,
        trendingSearchError: action.payload,
      };
    },
    getUrl404CheckSuccess(state, action) {
      return {
        ...state,
        url404Data: action.payload,
      };
    },
    getUrl404CheckFailure(state, action) {
      return {
        ...state,
        url404DataError: action.payload,
      };
    },
  },
});

export const {
  getFooterPwaLoading,
  getFooterPwaSuccess,
  getFooterPwaFailure,
  getHeaderLoading,
  getHeaderSuccess,
  getHeaderFailure,
  getHeaderSearchDataLoading,
  getHeaderSearchDataSuccess,
  getHeaderSearchDataFailure,
  getTrendingSearchLoading,
  getTrendingSearchSuccess,
  getTrendingSearchFailure,
  getUrl404CheckSuccess,
  getUrl404CheckFailure,
} = commonSlice.actions;
export const getFooterPwa = (params) => {
  return (dispatch) => {
    dispatch(getFooterPwaLoading());
    getFooterPwaRepo(params)
      .then((response) => {
        if (response?.status === 200) {
          dispatch(getFooterPwaSuccess(response?.data?.data));
        } else {
          dispatch(getFooterPwaFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFooterPwaFailure(error.message));
        }
      });
  };
};

export const headerData = (data) => {
  return (dispatch) => {
    dispatch(getHeaderLoading());
    getHeaderDataRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getHeaderSuccess(response?.data?.data));
        } else {
          dispatch(getHeaderFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getHeaderFailure(error.message));
        }
      });
  };
};

export const getHeaderSearchData = (params) => {
  return async (dispatch) => {
    dispatch(getHeaderSearchDataLoading());
    await getHeaderSearchDataRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getHeaderSearchDataSuccess(response?.data?.results));
        } else {
          dispatch(getHeaderSearchDataFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getHeaderSearchDataFailure(error.message));
        }
      });
  };
};

export const getTrendingSearch = (params) => {
  return async (dispatch) => {
    dispatch(getTrendingSearchLoading());
    await getTrendingSearchRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getTrendingSearchSuccess(response?.data?.data));
        } else {
          dispatch(getTrendingSearchFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getTrendingSearchFailure(error.message));
        }
      });
  };
};

export const check404Url = (params) => {
  return async (dispatch) => {
    await get404UrlCheckRepo(params)
    .then((response) => {
        if (response.status === 200) {
          dispatch(getUrl404CheckSuccess(response?.data));
        } else {
          dispatch(getUrl404CheckFailure(response?.message));
        }
      })
      .catch((error) => {
        dispatch(getUrl404CheckFailure(error));
      });
  };
};

export default commonSlice.reducer;
